export const mockPartnerRoles = {
  data: {
    roles: [
      { id: 'role-admin', displayName: 'Admin' },
      { id: 'role-member', displayName: 'Member' }
    ]
  }
}
